/* Hilario V2: optional desktop previews; all links navigate normally.
 * Pointer, keyboard and touch are deliberately handled separately.
 * No form, cart, analytics, booking or subscription code is involved.
 */
(() => {
  if (window.__hilarioNavigationV2) return;
  window.__hilarioNavigationV2 = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  const hover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  let keyboard = false;
  document.addEventListener('keydown', () => { keyboard = true; }, true);
  document.addEventListener('pointerdown', () => { keyboard = false; }, true);
  const controllers = new Set();
  function attach(root) {
    if (root.dataset.hilarioReady) return;
    root.dataset.hilarioReady = 'true';
    const entries = [...root.querySelectorAll('.hilario-nav-item')].map(item => ({
      item, details: item.querySelector('header-menu > details'), timer: null, inside: false
    }));
    function cancel(entry) { window.clearTimeout(entry.timer); entry.timer = null; }
    function close(entry, restoreFocus = false) {
      cancel(entry);
      if (!entry.details) return;
      const summary = entry.details.querySelector('summary');
      const content = summary.nextElementSibling;
      const focusWasInPanel = content && content.contains(document.activeElement);
      entry.details.open = false;
      summary.setAttribute('aria-expanded', 'false');
      if (restoreFocus && focusWasInPanel) summary.focus({preventScroll: true});
    }
    function open(entry) {
      cancel(entry);
      if (!desktop.matches || !entry.details) return;
      entries.forEach(other => { if (other !== entry) close(other); });
      entry.details.open = true;
      entry.details.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
    entries.forEach(entry => {
      entry.item.addEventListener('pointerenter', event => {
        if (!hover.matches || event.pointerType !== 'mouse') return;
        entry.inside = true; cancel(entry);
        entry.timer = window.setTimeout(() => {
          if (entry.details) open(entry);
          else entries.forEach(other => close(other));
        }, 100);
      });
      entry.item.addEventListener('pointerleave', event => {
        if (!hover.matches || event.pointerType !== 'mouse') return;
        entry.inside = false; cancel(entry);
        entry.timer = window.setTimeout(() => {
          if (!(keyboard && entry.item.contains(document.activeElement))) close(entry);
        }, 180);
      });
      if (!entry.details) return;
      entry.details.addEventListener('toggle', () => {
        entry.details.querySelector('summary').setAttribute('aria-expanded', String(entry.details.open));
        if (entry.details.open) entries.forEach(other => { if (other !== entry) close(other); });
      });
      entry.item.addEventListener('focusin', () => cancel(entry));
      entry.item.addEventListener('focusout', () => {
        cancel(entry);
        entry.timer = window.setTimeout(() => {
          if (!entry.item.contains(document.activeElement) && !entry.inside) close(entry);
        }, 0);
      });
    });
    const controller = {root, entries, close};
    controllers.add(controller);
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      entries.forEach(entry => close(entry, true));
    });
  }
  function init(scope = document) {
    if (scope.matches && scope.matches('[data-hilario-navigation]')) attach(scope);
    scope.querySelectorAll('[data-hilario-navigation]').forEach(attach);
  }
  function eachController(callback) {
    controllers.forEach(c => {
      if (!c.root.isConnected) { c.entries.forEach(e => c.close(e)); controllers.delete(c); }
      else callback(c);
    });
  }
  document.addEventListener('pointerdown', event => eachController(c => {
    c.entries.forEach(entry => { if (!entry.item.contains(event.target)) c.close(entry); });
  }), true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') eachController(c => c.entries.forEach(e => c.close(e, true)));
  });
  let lastScroll = window.scrollY;
  window.addEventListener('scroll', () => {
    if (Math.abs(window.scrollY - lastScroll) < 12) return;
    lastScroll = window.scrollY;
    eachController(c => c.entries.forEach(entry => {
      if (!(keyboard && entry.item.contains(document.activeElement))) c.close(entry);
    }));
  }, {passive: true});
  desktop.addEventListener('change', () => eachController(c => c.entries.forEach(e => c.close(e))));
  window.addEventListener('pageshow', () => eachController(c => c.entries.forEach(e => c.close(e))));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => eachController(() => {}));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
})();
